import './ShareImages.css';
import { useState } from 'react';
import Loader from '../Utils/Loader.js';
import apii from '../jobsite/Components/api.js';

let ShareImages=()=>{
    let [processing, setprocessing]=useState(false);
    let [selectedFiles, setselectedFiles]= useState(null); 
    //Handel file upload
let handelfilechange=(e)=>{
    setselectedFiles(e.target.files);
}
// Handel file submission
let submitbtn=async()=>{
    
    if(!selectedFiles || selectedFiles.length === 0){
        document.querySelector(".msgg").innerHTML='Please select at least one file';
        return;
    }
    document.querySelector(".fileinputandbtn").style.display = "none"; 
    document.querySelector(".msgg").innerHTML='';
    setprocessing("Please wait your Files/photos are uploading...");
    // append files to formdata
    const formdata = new FormData();
    for(let i=0; i < selectedFiles.length; i++){
        
        formdata.append('Images[]', selectedFiles[i]);
    }

    try { 
            const res = await apii.post('GetcustomersImages.php', formdata); 
            setprocessing(res.data.message);
            setInterval(() => {
            window.location.reload();
            }, 4000);
        } catch (error) {
        console.log(error);
    }

}


    return(
        <div className='uploadphotoofcustomers'>
            <p className='headinggg'>Share photos or Files</p>
            <p style={{fontSize:"24px", margin:"10px 0 0 0", color:"red"}} className='msgg'></p>
            <Loader  msg={processing}/> 
            <div className='fileinputandbtn'>
            <input multiple  type='file' onChange={handelfilechange}/>
            <button className='bbttnn' onClick={submitbtn}>Submit</button>
            </div>
        </div>
    );
}
export default ShareImages;